import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import config from "../../config";
import LoginChecked from "../Shared/LoginChecked";
import { Logos } from "../Shared/Logos";
import Logo from "../../assets/images/Logo/Logo.svg";
import { JsonToExcel } from "react-json-to-excel";

import {
  Space,
  Card,
  Form,
  Select,
  Spin,
  DatePicker,
  Table,
  Popconfirm,
  Pagination,
  Row,
  Col,
  Tooltip,
  Button,
  Input,
  message,
  Checkbox,
  Modal,
  Alert,
} from "antd";
import { NavLink, Link } from "react-router-dom";
import { PrintFormateNumber } from "../../Pdf/PrintFormateNumber";
import {
  CreditCardOutlined,
  DeleteOutlined,
  EditOutlined,
  ProfileOutlined,
  SearchOutlined,
  PlusOutlined,
  PrinterOutlined,
  DownloadOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import moment from "moment";
import {
  ArrowDownCircleIcon,
  ChevronLeftIcon,
} from "@heroicons/react/24/outline";
import AccountTypesDropdown from "../Shared/AccountTypesDropdown";
import BoxCard from "../Shared/BoxCard";
import { ArrowUpCircleIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import { NumberFormat } from "../Shared/Utility";
import { render } from "@testing-library/react";
import html2canvas from "html2canvas";

function ManageAccounts() {


  const InvoiceRef = useRef();
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const pumpName = localStorage.getItem("PumpName");
  const mobileNo = localStorage.getItem("Mobile_No")
  const [listofAccounts, SetlistofAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  const [AccountIdData, setAccountIdData] = useState("");
  const [InvoiceLoading, setInvoiceLoading] = useState(false);

  const [orderby, SetOrderBy] = useState("1");
  const [AccountTypeID, SetAccountTypeID] = useState(0);
  const [BalanceType, SetBalanceType] = useState("Balance Type");
  const [Dated, setDated] = useState(null);
  const [searchedName, setSearchedName] = useState("");
  const [DebitSum, SetDebitSum] = useState("");
  const [CreditSum, SetCreditSum] = useState("");
  const [Name, setName] = useState([]);
  const [HideZeroBalance, setHideZeroBalance] = useState(false);
  const [ExcelArray, setExcelArray] = useState([]);
  const [IsDeleted, setIsDeleted] = useState(false);

  const accountTypes = AccountTypesDropdown();
  const PumpLogo = localStorage.getItem("pumpLogo");

  const matchingLogo = Logos.find(logo => logo.title.toLowerCase() == PumpLogo.toLowerCase());


  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    document.title = "Manage Fuelbook Accounts";

    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      OrderBy: orderby,
      PageNo: pageNo,
      PageSize: pageSize,
      BalanceType: BalanceType,
      Account_Type_ID: AccountTypeID,
      Dated: Dated,
      Name: searchedName,
      HideZeroBalance: HideZeroBalance,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "account/GetAccounts",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {

        if (response.data.status_code == 1) {
          // Handle success
          SetlistofAccounts(response.data.listofAccounts);
          SetDebitSum(response.data.DebitSum);
          SetCreditSum(response.data.CreditSum);
          setTotalRecords(response.data.totalRecords);
          setName(response.data.listofAccounts?.Name);

          const exceldata = response.data.listofAccounts;
          if (exceldata != null && exceldata.length > 0) {
            let count = 0;

            const listOfLedgerNew = exceldata.map((item, index) => ({
              Serial_No: index + 1,
              Username: item.Name,
              Mobile_No: item.Mobile_No,
              Account_Type: item.Account_Type_BE?.Name,
              Balance: "PKR " + item.Balance,
              BalanceType: item.BalanceType,
            }));

            setExcelArray(listOfLedgerNew);
          }
          setLoading(false);
        } else {
          // Handle error
          setLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        message.error("Network Error");
        console.log(error);
      });
  }, [
    AccountTypeID,
    BalanceType,
    orderby,
    Dated,
    pageNo,
    pageSize,
    searchedName,
    HideZeroBalance,
    IsDeleted, InvoiceLoading
  ]);

  const handleSearchByName = (e) => {
    setSearchedName(e.target.value);
  };

  const handelDelete = (ID, balance) => {
    if (Math.abs(Number(balance) || 0) !== 0) {
      message.error("Cannot delete an account with a non-zero balance.");
      return;
    }

    setIsDeleted(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      ID: ID,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Account/DeleteAccount",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {

        if (response.data.status_code === 1) {
          setIsDeleted(false);
          message.success(response.data.status_message);
        } else {
          setIsDeleted(false);
          message.error(response.data.status_message);
        }
      })
      .catch(function (error) {
        setIsDeleted(false);
      });
  };

  const columns = [
    {
      title: "SR",
      dataIndex: "Sr",
      key: "Sr",
      sorter: true,
      render: (_, record, index) => index + 1 + pageSize * (pageNo - 1),
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      sorter: true,
      render: (_, record) => (<NavLink to={`/accounts/account-ledger/?account_id=${record.ID}`}>{record.Name}</NavLink>)
    },
    {
      title: "Mobile",
      dataIndex: "Mobile_No",
      key: "Mobile_No",
    },
    {
      title: "Account Type",
      dataIndex: "Account_Type_BE",
      key: "Account_Type_BE",
      render: (accountTypeBE) => {

        return accountTypeBE ? accountTypeBE.Name : "";
      },
    },

    {
      title: "Current Balance ",
      dataIndex: "Balance",
      key: "balance",
      sorter: true,
      align: "right",
      render: (_, record) => {
        return NumberFormat(record.Balance, 0);
      },
    },
    {
      title: "Type",
      dataIndex: "BalanceType",
      key: "type",
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <div className="account-actions">
            <Space size="middle">
              <div className={`${record.Is_Default ? "hidden" : ""}`}>
                <Tooltip title="Edit Account">
                  <NavLink to={`/accounts/edit-account/${record.ID}`}>
                    <EditOutlined />
                  </NavLink>
                </Tooltip>
              </div>
              <div className={`${record.Is_Default ? "hidden" : ""}`}>
                {Math.abs(Number(record.Balance) || 0) !== 0 ? (
                  <Tooltip title="Cannot delete account with a non-zero current balance">
                    <span>
                      <DeleteOutlined
                        style={{ color: "#bfbfbf", cursor: "not-allowed" }}
                      />
                    </span>
                  </Tooltip>
                ) : (
                  <Tooltip title="Delete">
                    <Popconfirm
                      title="Sure to delete?"
                      description="Are you sure you want to delete this account?"
                      onConfirm={() => handelDelete(record.ID, record.Balance)}
                    >
                      <DeleteOutlined />
                    </Popconfirm>
                  </Tooltip>
                )}
              </div>
              <div className={`${record.Is_Default && record.Name !== "Cash" ? "hidden" : ""}`}>
                <Tooltip title="Customer Rates">
                  <NavLink
                    to={`/accounts/custom-rates/?ID=${record.ID}&Name=${record.Name}`}
                  >
                    <CreditCardOutlined />
                  </NavLink>
                </Tooltip>
              </div>
              <div>
                <Tooltip title="View Ledger">
                  <NavLink
                    to={`/accounts/account-ledger/?account_id=${record.ID}`}
                  >
                    <ProfileOutlined />
                  </NavLink>
                </Tooltip>
              </div>
            </Space>
          </div>
        </>
      ),
    },
    {
      title: "Share",
      key: "share",
      render: (_, record) => (
        <>
          <div className="account-actions" style={{ cursor: 'pointer' }} onClick={() => showModal(record.ID)}>
            <Tooltip title="Share Balance">
              <WhatsAppOutlined />
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const onPageChange = (page, pageSize) => {
    setPageNo(page);
  };

  const onPageSizeChange = (current, size) => {
    setPageNo(1);
    setPageSize(size);
  };

  const confirm = (e) => {

    message.success("Data deleted successfully");
  };



  const handleTableChange = async (pagination, filters, sorter) => {
    // Make API request with sorting parameters
    const sortField = sorter.field;
    const sortOrder = sorter.order === "descend" ? "desc" : "asc";

    if (sortField == "Name") {
      if (sortOrder == "asc") {
        SetOrderBy(1);
      } else {
        SetOrderBy(2);
      }
    } else if (sortField == "Balance") {
      if (sortOrder == "asc") {
        SetOrderBy(3);
      } else {
        SetOrderBy(4);
      }
    }
    else if (sortField == "Sr") {
      if (sortOrder == "asc") {
        SetOrderBy(5);
      } else {
        SetOrderBy(6);
      }
    }

  };

  // 5 created asc
  // 6 created dsc


  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = (id) => {
    setInvoiceLoading(true)
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: id,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "account/GetAccountbyIDWithBalance",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setAccountIdData(response.data);
          setIsModalOpen(true);
          setInvoiceLoading(false)
        } else {
          setInvoiceLoading(false)
        }
      })
      .catch(function (error) {
        // console.log(error);
      });

  };



  const handleOk = (id) => {
    setIsModalOpen(false);


  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const shareImage = async () => {

    setInvoiceLoading(true);

    try {
      // Capture the HTML element (InvoiceRef) as a canvas
      const canvas = await html2canvas(InvoiceRef.current);
      const imgData = canvas.toDataURL("image/jpeg");

      // Create a Blob from the image data

      const response = await fetch(imgData);
      const blob = await response.blob();
      const file = new File([blob], "Withdraw Invoice.jpg", { type: "image/jpeg" });

      // Use Web Share API if supported by the browser
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: "Invoice",
          text: "Here is the invoice.",
        });


        setTimeout(() => {
          setInvoiceLoading(false);
          setIsModalOpen(false);
          message.success('Invoice shared successfully!');
        }, 1000);
      } else {
        alert("Sharing is not supported on your browser.");
        setInvoiceLoading(false);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error capturing or sharing image:", error);
      setInvoiceLoading(false);
      setIsModalOpen(false);
      message.error('Failed to share invoice!');
    }
  };

  return (
    <>

      <Modal title="Customer Balance" open={isModalOpen} footer={false} onCancel={handleCancel} loading={InvoiceLoading}>
        <div className="whatsapp-invoice" ref={InvoiceRef}>
          <div className="invoice-head">
            <img src={matchingLogo.src} style={{ height: "100px", width: "100px" }} />
            <span>{moment(AccountTypeID.OpeningDate).format("MMMM D, YYYY [at] h:mm A")}</span>
          </div>
          <div className="invoice-body">
            <div className="price">
              <h5>Current Balance ({AccountIdData.BalanceType})</h5>
              <h1>Rs. {NumberFormat(AccountIdData.Balance)}</h1>
            </div>
            <ul>
              <li>
                <span>Name</span>
                <p>{AccountIdData.Name}</p>
              </li>
              <li>
                <span>Mobile</span>
                <p>{AccountIdData.Mobile_No}</p>
              </li>
            </ul>
          </div>
          <div className="invoice-footer">

            <a>{pumpName}</a>

            <a href={mobileNo}>{mobileNo}</a>
          </div>

        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>

          <Button onClick={handleCancel}>Cancel</Button>
          <Button type='primary' onClick={shareImage}>Share Invoice</Button>
        </div>
      </Modal>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">
              {/* <NavLink to="/company/manage">
                <ChevronLeftIcon />
              </NavLink> */}
              Manage Accounts
              <Tooltip title="View deleted accounts">
                <NavLink
                  to="/accounts/deleted-accounts"
                  style={{ marginLeft: 10, verticalAlign: "middle" }}
                >
                  <DeleteOutlined style={{ fontSize: 18, color: "#8c8c8c" }} />
                </NavLink>
              </Tooltip>
            </h3>

            <div className="header-actions">
              <Row gutter={[12, 12]}>

                <Col md={8} xs={12}>
                  <NavLink
                    to={`/accounts/print-account-list/?OrderBy=${orderby}&BalanceType=${BalanceType}&Account_Type_ID=${AccountTypeID}&Dated=${Dated}&Name=${searchedName}&HideZeroBalance=${HideZeroBalance}`}
                    target="blank"
                  >
                    <Button
                      type="dashed"
                      shape="round"
                      size="large"
                      icon={<PrinterOutlined />}
                    >
                      Download / Print
                    </Button>
                  </NavLink>
                </Col>
                <Col md={8} xs={12}>
                  <JsonToExcel
                    title="Export In Excel"
                    data={ExcelArray}
                    fileName={`Fuelbook Accounts_${dayjs().format("DD-MM-YYYY")}`}
                    btnClassName="excel-button"
                  />
                </Col>



                <Col md={8} xs={12}>
                  <NavLink to="/accounts/add-account">
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      icon={<PlusOutlined style={{ color: "white" }} />}
                    >
                      Add Account
                    </Button>
                  </NavLink>
                </Col>

              </Row>
            </div>
          </div>
          <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
            <Col md={6} xs={24}>
              <BoxCard
                loading={loading}
                title="Total Debit"
                amount={NumberFormat(DebitSum, 2)}
                prefix="Rs."
                icon={
                  <ArrowDownCircleIcon
                    stroke="#32a844"
                    height={30}
                    width={30}
                  />
                }
              />
            </Col>
            <Col md={6} xs={24}>
              <BoxCard
                loading={loading}
                title="Total Credit"
                amount={NumberFormat(CreditSum, 2)}
                prefix="Rs."
                icon={
                  <ArrowUpCircleIcon
                    stroke="#ff1c1c"
                    height={30}
                    width={30}
                  />
                }
              />
            </Col>
          </Row>
          {(() => {
            const d = Number(DebitSum);
            const c = Number(CreditSum);
            const bad =
              !loading &&
              !Number.isNaN(d) &&
              !Number.isNaN(c) &&
              Math.abs(d - c) > 0.01;
            return bad ? (
              <Alert
                type="warning"
                showIcon
                message="Debit and credit totals do not match"
                description={
                  <>
                    Trial balance should be equal in double-entry bookkeeping. Use{" "}
                    <NavLink to="/accounts/posting-integrity">posting diagnostics</NavLink> to
                    find voucher, sale, or purchase groups where ledger debits and credits do not
                    match.
                  </>
                }
                style={{ marginBottom: 16 }}
              />
            ) : null;
          })()}
          <div className="filters-wrap">
            <Form>
              <Form.Item>
                <Input
                  allowClear
                  placeholder="Search By Name"
                  value={searchedName}
                  onChange={handleSearchByName}
                />
              </Form.Item>

              <Form.Item>
                <Select
                  allowClear
                  showSearch
                  style={{
                    width: "200px",
                  }}
                  placeholder="Account Type"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => SetAccountTypeID(value)}
                  options={accountTypes}
                />
              </Form.Item>

              <Form.Item>
                <Select
                  showSearch
                  style={{
                    width: 150,
                  }}
                  placeholder="Balance Type"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  onChange={(value) => SetBalanceType(value)}
                  value={BalanceType}
                  allowClear
                  options={[
                    {
                      value: "Debit",
                      label: "Debit",
                    },
                    {
                      value: "Credit",
                      label: "Credit",
                    },
                  ]}
                />
              </Form.Item>

              <Form.Item>
                <DatePicker
                  placeholder="Balance on Date"
                  onChange={(date, dateString) => setDated(dateString)}
                  disabledDate={disabledDate}
                />
              </Form.Item>
              <Form.Item>
                <Checkbox onClick={() => setHideZeroBalance((prev) => !prev)}>
                  Hide Zero Balance
                </Checkbox>
              </Form.Item>
            </Form>
          </div>
          <Table
            size="small"
            scroll={{
              x: "100%",
            }}
            loading={loading}
            columns={columns}
            dataSource={listofAccounts}
            pagination={false}
            onChange={handleTableChange}
            bordered
          />

          <div className="text-end mt-5">
            <Pagination
              current={pageNo}
              pageSize={pageSize}
              size="small"
              total={totalRecords}
              onChange={onPageChange}
              onShowSizeChange={onPageSizeChange} // Handle page size change
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageAccounts;
